export var Scroll=/*#__PURE__*/function(a){return a.CONTENT="content",a.VIEWPORT="viewport",a}({});